module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-start-btn-fill-d64933ef.svg";